import { DatePipe } from "@angular/common"
import { AgColDefsI, AgGridI } from "src/app/shared/common-components/ag-grid/ag-grid.model"
import { CustomExpandableComponent } from "src/app/shared/common-components/ag-grid/custom-expandable/custom-expandable.component"
import { CustomHeaderComponent } from "src/app/shared/common-components/ag-grid/custom-header/custom-header.component"
import { ResetDeleteIconComponent } from "src/app/shared/common-components/ag-grid/reset-delete-icon/reset-delete-icon.component"
import { TextRendererComponent } from "src/app/shared/common-components/ag-grid/text-renderer/text-renderer.component"
import { paginationModel } from "src/app/shared/models/common.model"
import { TextSvgCellrenderComponent } from "../../shared/common-components/ag-grid/text-svg-cellrender/text-svg-cellrender.component"

export class Transaction{

}

export enum TransactionTabs{
    PayVoucher = 1,
    ReceiveVoucher =2
}

export enum VoucherType{
  PaymentVoucher = 4,
  ReceiptVoucher = 5,
}

export enum VoucherTypeName{
  PaymentVoucher = "Payment Voucher",
  ReceiptVoucher = "Receipt Voucher",
}

export class VoucherModel {
    id: string
    date: string
    comment: string=null
    voucherNo: string
    voucherType: string
    transactionModel: TransactionModel[]=[]
  }
  
  export class TransactionModel {
    id: string;
    ledgerId: string=null;
    transLedgerId: string=null;
    credit: number=null;
    debit: number=null;
    comment: string;
    voucherTypeId: string=null;
    voucherId: string=null;
    transactionNo: string;
    transactionDate: string;
    amount: number;
    transferFromId: string;
  }

  export class PaymentVoucherList extends paginationModel{
    id:string;
    voucherType?:string;
  }



  export class PaymentVoucherModel {
    paymentMaster = new VoucherMaster();
    paymentList: VoucherList[]=[]
  }

  export class VoucherMaster {
    id: string=null;
    voucherNo: string=null;
    voucherType: string=null;
    accountLedgerId: any=null;
    date: string=null;
    totalAmount: number=null;
    comment: string=null;
  }
  
  export class VoucherList {
  id: string=null;
  paymentMasterId: string=null;
  paymentMethodId: number=null;
  depositeIntoId: string=null;
  transferFromId: string=null;
  transactionNo: string=null;
  transactionDate: string=null;
  againstVoucherId: string=null;
  amount: number=null;
  }


  export class ReceiptVoucherModel {
    receiptMaster = new VoucherMaster();
    receiptList:VoucherList[]=[];
   
  }


  // ag grid paymenthistory 

const ExpandableColumn: AgColDefsI =
{
  headerName: "",
  field: "isExpandable",
  lockPosition: "left",
  headerComponent: CustomHeaderComponent,
  suppressMovable: false,
  wrapText: true,
  sortable: false,
  autoHeight: true,
  editable:false,
  resizable: false,
  cellClass: "custom-column-group-cell text-end ",
  minWidth: 0,
  maxWidth: 0,
  flex: 0,
  cellStyle: {
    position: "relative",
    top: "0",
    minWidth: "100%",
  },
  cellClassRules: { "borders-0": (params) => !params?.data?.isExpandable ?? false, },
  cellRenderer: CustomExpandableComponent,
  cellRendererParams: { context: this },
  width: 0,
}

const LedgerNameColumn: AgColDefsI = 
{
  headerName: "Name",
  headerComponent: CustomHeaderComponent,
  sortable: true,
  field: "accountLedgerName",
  headerClass: "custom-column-group-cell",
  cellClass: "custom-column-group-cell",
  flex: 3,
  minWidth: 100,
  cellRenderer: TextRendererComponent,
  cellRendererParams :{isCursor:true},
  lockPinned: true,
  lockPosition: 'left',
  suppressMovable:false,
  editable:false
}
const DateColumn: AgColDefsI = 
{
  headerName: "Date",
  headerComponent: CustomHeaderComponent,
  sortable: true,
  field: "date",
  minWidth: 100,
  headerClass: "custom-column-group-cell",
  cellClass: "px-1 custom-column-group-cell d-flex align-item-center",
  flex: 1,
  editable:false,
  cellRenderer: TextSvgCellrenderComponent,
}

const StatusName: AgColDefsI = {
  headerName: "Status", 
  field: 'statusName', 
  minWidth: 100,
  headerComponent: CustomHeaderComponent,
  sortable: true,
  editable:false,
  cellRenderer:TextRendererComponent
};
const VoucherNoColumn: AgColDefsI = {
  headerName: "Voucher No.",
  field: "voucherNo",
  headerComponent: CustomHeaderComponent,
  sortable: true,
  cellRenderer: TextRendererComponent,
  editable:false,
  minWidth: 60,
 headerClass: "custom-column-group-cell",
    cellClass: "custom-column-group-cell",
  flex: 2,
}
const ActionColumn: AgColDefsI = {
  headerName: "", 
  field: '', 
  suppressNavigable: true,
  suppressMovable:false,
  editable: false,
  minWidth: 60,
  maxWidth: 60,  
  lockPosition:'right',  
  headerClass:" px-0 ag_header_center",
  headerComponentParams:{enablePlusIcon:true},
  sortable: false,
  cellRendererParams: {
  isDeleteIcon:true,
  editIcon: true,
  lockPinned:true, 
  pinned: 'right',
  },
  cellRenderer:ResetDeleteIconComponent,
  cellClass:"gap-5",
};

  export const payvoucherHistoryColDef:AgColDefsI[] = [
    // ExpandableColumn,
  LedgerNameColumn,
  DateColumn,
  VoucherNoColumn,
  ActionColumn
  ]

  export const AgGridDataModelPayVoucherHistory: AgGridI = {
    colDefs: payvoucherHistoryColDef,
    
  rowSelection: "multiple",
  rowHeight:40,
  }